export default __webpack_public_path__ + "static/media/OSMOS_RUGGINE_C2_GRIP_120X120_01.9d37ac63.jpg";